import type { AttributeField } from "@/features/properties/types/propertyAttributes";

export interface TemplateField {
  id: string;
  type: string;
  title: string;
  options?: string[] | null;
  fields?: TemplateField[];
  hint?: string | null;
  required?: boolean;
}

/**
 * Returns the field's children if it has any, or null if it's a leaf.
 *
 * Treats any field with a populated `fields` array as a section, regardless
 * of its `type` value — handles edge cases where grouping fields in the
 * source JSON may not declare type === "node".
 */
export function getChildren(field: AttributeField): AttributeField[] | null {
  const maybe = (field as { fields?: unknown }).fields;
  if (Array.isArray(maybe) && maybe.length > 0) {
    return maybe as AttributeField[];
  }
  return null;
}

export function collectEvidenceUrls(field: AttributeField): string[] {
  const urls: string[] = [];
  const evidence = (field as { evidence?: unknown }).evidence;
  if (Array.isArray(evidence)) {
    urls.push(...evidence.filter((url): url is string => typeof url === "string" && url.trim() !== ""));
  }
  if (field.type === "photos" && Array.isArray(field.value)) {
    urls.push(...field.value.filter((url): url is string => typeof url === "string" && url.trim() !== ""));
  }
  return Array.from(new Set(urls));
}
